import InsightHighlightsAction from '../actions/insightHighlights/InsightHighlightsAction'
import { InsightHighlight } from '../../interfaces/InsightHighlight'

type State = {
  isFetching: boolean,
  highlights?: InsightHighlight[]
}

class InsightHighlightsReducer {

  static initialState: State = {
    isFetching: false,
    highlights: undefined
  }

  static reducer = (state = InsightHighlightsReducer.initialState, action) => {
    switch (action.type) {
      case InsightHighlightsAction.REQUEST_INSIGHT_HIGHLIGHTS:
        return {
          ...state,
          isFetching: true
        }
      case InsightHighlightsAction.RECEIVE_INSIGHT_HIGHLIGHTS:
        return {
          ...state,
          highlights: action.payload.highlights,
          isFetching: false
        }
    }
    return state
  }
} 

export default InsightHighlightsReducer